import { render, staticRenderFns } from "./GoodsTrace.vue?vue&type=template&id=6ea9e1fc&scoped=true"
import script from "./GoodsTrace.vue?vue&type=script&lang=js"
export * from "./GoodsTrace.vue?vue&type=script&lang=js"
import style0 from "./GoodsTrace.vue?vue&type=style&index=0&id=6ea9e1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea9e1fc",
  null
  
)

export default component.exports